<template>
  <div class="content contentA">
    <div class="box">
      <div class="box-title">
        <span style="font-size:16px;display:flex;"><el-page-header @back="$router.go(-1)">
</el-page-header>巡查库管理</span>
        <div>
          <div class="btn" style="font-size:16px" @click="add">添加</div>
        </div>
      </div>
      <div class="box-cont">
        <el-table
          height="72vh"
          :header-cell-style="{background:'#F5F7F9'}"
          border
          :data="treeData"
          style="width: 100%"
          row-key="id"
          :tree-props="{children: 'sysSafeLists'}">
          <!-- <el-table-column type="expand">
            <template slot-scope="scope">
              <el-table
                :show-header="false"
                :data="scope.row.chid"
                style="width: 100%">
                <el-table-column
                  prop="name"
                  label="名称"
                  >
                </el-table-column>
                <el-table-column
                  
                  label="操作"
                  width="230">
                  <template slot-scope="scope">
              <div>
                <i  class="el-icon-edit"></i>
                <i class="el-icon-delete"></i>
                <i class="el-icon-folder-add"></i>
              </div>
            </template>
                </el-table-column>
              </el-table>
            </template>
          </el-table-column> -->
          <el-table-column
            prop="label"
            label="名称">
          </el-table-column>
          <el-table-column
            label="操作"
            width="230">
            <template slot-scope="scope">
              <div class="shezhi">
                <div @click="edit(scope.row)" class="edit">编辑</div>
                <div @click="addChil(scope.row)" class="add">添加</div>
                <div @click="del(scope.row)" class="delete">删除</div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <!-- 弹出框 -->
        <el-dialog
          class="dialog"
          :visible.sync="addDialog"
          width="600px"
          center>
          <p slot="title" class="dialog-title">新建标准</p>
          <el-form  label-position="right" label-width="180px">
            <el-form-item label="名称：">
              <el-input v-model="addForm.label" size="medium" placeholder="请输入名称"></el-input>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button size="small" @click="addDialog = false">取 消</el-button>
            <el-button size="small" type="primary" @click="submitForm1" style="background-color: #4D6EB1">确 定</el-button>
          </span>
        </el-dialog>
        <!-- 弹出框2 -->
        <el-dialog
          class="dialog"
          :visible.sync="addDialog1"
          width="600px"
          center>
          <p slot="title" class="dialog-title">新建子集标准</p>
          <el-form  label-position="right" label-width="180px">
            <el-form-item label="所属项：">
              <el-input
                v-model="name"
                :disabled="true">
              </el-input>
            </el-form-item>
            <el-form-item label="名称：">
              <el-input v-model="addForm1.label" size="medium" placeholder="请输入名称"></el-input>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button size="small" @click="addDialog1 = false">取 消</el-button>
            <el-button size="small" type="primary" @click="submitForm2" style="background-color: #4D6EB1">确 定</el-button>
          </span>
        </el-dialog>
        <!-- 弹出框3 -->
        <el-dialog
          class="dialog"
          :visible.sync="addDialog2"
          width="600px"
          center>
          <p slot="title" class="dialog-title">编辑</p>
          <el-form  label-position="right" label-width="180px">
            <el-form-item label="名称：">
              <el-input v-model="addForm2.label" size="medium" placeholder="请输入名称"></el-input>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button size="small" @click="addDialog2 = false">取 消</el-button>
            <el-button size="small" type="primary" @click="submitForm3" style="background-color: #4D6EB1">确 定</el-button>
          </span>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
  import base from '../../../untils/base'
  import myHttp from '../../../untils/port'
  import util from '../../../untils/util'
  export default {
    data() {
      return {
        addDialog:false,
        addDialog1:false,
        addDialog2:false,
        list: [
          {
            id:1,
            name:'小明',
            children:[
              {
                id:11,
                name:'小紅'
              }
            ]
          },
          {
            id:2,
            name:'小a',
          }
        ],
        label:'',
        treeData:[],
        addForm: {
          type: 'safe_check',
          label: '',
          parentId: 0,
          value:'2',
          projectId:util.session.get('groupId')

        },
        name:'',
        addForm1: {
          type: 'safe_check',
          label: '',
          parentId: 0,
          value:'2',
          projectId:util.session.get('groupId')
        },
        addForm2: {
          label: '',
          id:''
        },
      }
    },
    mounted(){
      this.getTreeList()
    },
    methods:{
      del(item){
        this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            myHttp.deleteInfoNew1({
              id:item.id
            }).then(res=>{
              if(res.data.code){
                this.getTreeList()
                this.$message({
                  type: 'success',
                  message: `${res.data.msg}`
                })
              }
            })
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            })          
          })
      },
      addChil(item){
        this.name=item.label
        this.addForm1.parentId = item.id
        this.addDialog1=true
      },
       add(){
        this.addForm.label = ''
        this.addDialog = true
      },
      submitForm1(){
         myHttp.createInfoNews(this.addForm).then(resp => {
          if(resp.data.code === 200){
            this.$message.success('添加成功！！')
            this.addDialog = false
            this.getTreeList()
          }else{
            this.$message.error(resp.data.msg)
          }
        })
      },
      submitForm2(){
         myHttp.createInfoNews(this.addForm1).then(resp => {
          if(resp.data.code === 200){
            this.$message.success('添加成功！！')
            this.addDialog1 = false
            this.getTreeList()
          }else{
            this.$message.error(resp.data.msg)
          }
        })
      },
      submitForm3(){
         myHttp.updateInfoNews(this.addForm2).then(resp => {
          if(resp.data.code === 200){
            this.$message.success('添加成功！！')
            this.addDialog2 = false
            this.getTreeList()
          }else{
            this.$message.error(resp.data.msg)
          }
        })
      },
      edit(item){
        this.addDialog2 = true
        this.addForm2.label = item.label
        this.addForm2.id = item.id
      },
      getTreeList(){
        myHttp.getListByEntity({
          label: this.label,
          type: 'safe_check',
          parentId: 0,
          id: '',
          // value:'2',
        }).then(resp => {
          if(resp.data.code === 200){
            this.treeData = resp.data.data.user
            console.log(this.treeData)
            // if(this.obj.safeId){
            //   setTimeout( () => {
            //     this.$refs.tree.setCurrentKey(this.obj.safeId)
            //   }, 100)
            // }
          }else{
            this.$message.error(reps.data.msg)
          }
        })
      },
    }
  }
</script>

<style scoped>
.content{
  height: 100%;
  /* padding: 1vh 1vw; */
  display: flex;
  flex-direction: row;
  /* background-color: #fff; */
}

.contentA{
  padding: 15px 20px 15px 8px;
  
}
.box{
  background-color: #fff;
  width: 100%;
  height: 100%;
  border-radius: 5px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.box-title{
  height: 4.8vh;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 8px;
  border-bottom: 2px solid #eee;
}
.box-cont{
  flex: 1;
  padding: 0.5vw;
  padding-top:20px ;
}
.edit{
  color: #108c53;
  font-size: 14px;
}
.delete{
  color: #dd5a43;
  font-size: 14px;
}
.add{
  color: #1e5edb;
  font-size: 14px;
}
.edit:hover{
  opacity: 0.6;
  cursor: pointer;
}
.delete:hover{
  opacity: 0.6;
  cursor: pointer;
}
.add:hover{
  opacity: 0.6;
  cursor: pointer;
}
.shezhi{
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 18%;
}
::v-deep .cell{
  text-align: start;
  font-size: 14px;
}
::v-deep .el-icon-arrow-right{
  font-size: 14px !important;
}
.btn{
  width: 80px;
  height: 32px;
  border-radius: 6px;
  background: #FDFEFE;
  box-sizing: border-box;
  border: 1px solid #999999;
  display: flex;
  justify-content: center;
  align-items: center;
}
.btn:hover{
  cursor: pointer;
  opacity: 0.6;
}
</style>